<h2 mat-dialog-title> Nuevo usuario</h2>
<mat-dialog-content>

  <mat-tab-group animationDuration="0ms">
    <mat-tab label="Información" class='tab'>
      <form [formGroup]="form">
        <mat-form-field class='formField'>
          <mat-label>Nombre</mat-label>
          <input matInput placeholder="Nombre" formControlName="name" required>
          <mat-error>El nombre es obligatorio</mat-error>
        </mat-form-field>
        <mat-form-field class='formField'>
          <mat-label>Apellidos</mat-label>
          <input matInput placeholder="Apellidos" formControlName="surname" required>
          <mat-error>Los apellidos son obligatorios</mat-error>
        </mat-form-field>
        <mat-form-field class='formField'>
          <mat-label>Email</mat-label>
          <input matInput placeholder="Email" formControlName="email" required>
          <mat-error>El email es obligatorio</mat-error>
        </mat-form-field>
        <mat-form-field class='formField'>
          <mat-label>Contraseña</mat-label>
          <input matInput placeholder="Contraseña" formControlName="password" required>
          <mat-error>La contraseña es obligatoria</mat-error>
        </mat-form-field>
        <!--<mat-form-field class='formField'>
          <mat-label>Rol</mat-label>
          <mat-select formControlName="rol" required>
            <mat-option value="admin">Administrador</mat-option>
            <mat-option value="trans">Transportista</mat-option>
            <mat-option value="clasi">Clasificador</mat-option>
            <mat-option value="ofici">Oficina</mat-option>
          </mat-select>
          <mat-error>El rol es obligatorio</mat-error>
        </mat-form-field>-->
        <mat-form-field class='formField'>
          <mat-label>Estado</mat-label>
          <mat-select formControlName="active" required>
            <mat-option value="true">Activo</mat-option>
            <mat-option value="false">Inactivo</mat-option>
          </mat-select>
          <mat-error>El estado es obligatorio</mat-error>
        </mat-form-field>
      </form>
    </mat-tab>
    <mat-tab label="Permisos" class='tab'>
      <table class='table'>
        <tr>
          <td>Total</td>
          <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_total"></mat-slide-toggle></td>
        </tr>
        <tr>
          <td>Pesar</td>
          <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_pesar"></mat-slide-toggle></td>
        </tr>
        <tr>
          <td>Clasificar</td>
          <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_clasificar"></mat-slide-toggle></td>
        </tr>
        <tr>
          <td>Ver registros</td>
          <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_registros"></mat-slide-toggle></td>
        </tr>
        <tr>
          <td>Modificar datos</td>
          <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_registrosDatos"></mat-slide-toggle></td>
        </tr>
        <tr>
          <td>Modificar pesos</td>
          <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_registrosPesos"></mat-slide-toggle></td>
        </tr>
        <tr>
          <td>Gestión usuarios</td>
          <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_usuarios"></mat-slide-toggle></td>
        </tr>
        <tr>
          <td>Gestión contenedores</td>
          <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_contenedores"></mat-slide-toggle></td>
        </tr>
        <tr>
          <td>- Alta movimiento</td>
          <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_contenedores_alta_movimientos"></mat-slide-toggle></td>
        </tr>
        <tr>
          <td>- Alta movimiento</td>
          <td><mat-slide-toggle color='primary' [(ngModel)]="permiso_contenedores_alta_mantenimientos"></mat-slide-toggle></td>
        </tr>
      </table>
    </mat-tab>
  </mat-tab-group>

</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button (click)="close()">Cancelar</button>
  <button mat-button (click)="save()">Añadir</button>
</mat-dialog-actions>
